import { generatePath } from 'react-router-dom';
import { createDatasetSlice, ResponseMapping } from 'src/redux/helpers';
import { pepApiRequest, RequestMethod } from 'src/services';
import {
  API_GET_ASSET_ALL_CONFIG_LIST,
  SOLUTIONS_STORE,
  SOLUTIONS_STORE_ASSET_ALL_CONFIG,
} from '../constants';
import { mapSolutionsAssetConfigListData } from './utils';

const api = ({ solutionId, twinId, pageIndex, pageSize, sortOrder }) =>
  pepApiRequest({
    method: RequestMethod.Get,
    url: generatePath(API_GET_ASSET_ALL_CONFIG_LIST, {
      solutionId,
      twinId,
    }),
    queryParams: { pageNumber: pageIndex, pageSize, sortOrder },
  }).then(mapSolutionsAssetConfigListData);

const assetConfigList = createDatasetSlice({
  api,
  storeName: SOLUTIONS_STORE,
  actionName: SOLUTIONS_STORE_ASSET_ALL_CONFIG,
});

export default assetConfigList;
